module.exports = __webpack_public_path__ + "img/close-filter.f13e2330.svg";